import { useEffect, useState } from "react";

export const scrollToSection = (href) => {
  const el = document.querySelector(href);
  if (!el) return;
  if (window.__lenis) {
    window.__lenis.scrollTo(el, { offset: -64, duration: 1.4 });
  } else {
    el.scrollIntoView({ behavior: "smooth" });
  }
};

const LINKS = [
  { label: "About", href: "#about", testid: "nav-link-about" },
  { label: "Ventures", href: "#ventures", testid: "nav-link-ventures" },
  { label: "Books", href: "#books", testid: "nav-link-books" },
  { label: "Contact", href: "#contact", testid: "nav-link-contact" },
];

export const LogoMark = ({ className = "h-8 w-8" }) => (
  <svg viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
    <rect width="40" height="40" fill="#121214" />
    <path d="M8 8H32V14H16V22H28V28H16V32H8V8Z" fill="#E24A24" />
    <circle cx="32" cy="32" r="4" fill="#F4F4F0" />
  </svg>
);

export default function Nav() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const handleClick = (e, href) => {
    e.preventDefault();
    scrollToSection(href);
  };

  return (
    <header
      data-testid="nav-header"
      className={`fixed inset-x-0 top-0 z-40 border-b transition-all duration-500 ${
        scrolled
          ? "border-line bg-black/70 backdrop-blur-xl"
          : "border-transparent bg-transparent"
      }`}
    >
      <div className="mx-auto flex max-w-[1600px] items-center justify-between px-6 py-4 sm:px-12">
        <a
          href="#top"
          data-testid="nav-link-hero"
          onClick={(e) => handleClick(e, "#top")}
          className="flex items-center gap-3"
        >
          <LogoMark />
          <span className="font-serif text-xl tracking-wide text-bone">
            Forbes<span className="text-vermilion">.</span>
          </span>
        </a>
        <nav className="flex items-center gap-6 sm:gap-10">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={l.testid}
              onClick={(e) => handleClick(e, l.href)}
              className="group relative hidden font-mono text-[11px] uppercase tracking-[0.25em] text-ash transition-colors duration-300 hover:text-bone sm:inline"
            >
              {l.label}
              <span className="absolute -bottom-1 left-0 h-px w-0 bg-vermilion transition-all duration-300 group-hover:w-full" />
            </a>
          ))}
          <a
            href="#contact"
            data-testid="nav-cta-button"
            onClick={(e) => handleClick(e, "#contact")}
            className="inline-flex items-center gap-2 border border-vermilion/50 px-5 py-2 font-mono text-[11px] uppercase tracking-[0.25em] text-vermilion transition-all duration-300 hover:bg-vermilion hover:text-ink"
          >
            Inquire
          </a>
        </nav>
      </div>
    </header>
  );
}